import { useQuery } from '@tanstack/react-query'

import { getInfoClient } from '@/lib/utils/hyper.sdk.utils'
import type { PortfolioPeriods } from '@/lib/utils/hyper/types'

/**
 * Hook to fetch portfolio data from Hyperliquid API
 * @param userAddress - The user's wallet address
 * @returns Query result with portfolio data
 */
export function usePortfolioData(userAddress: string) {
  return useQuery({
    queryKey: ['portfolio', userAddress],
    queryFn: async (): Promise<PortfolioPeriods> => {
      const infoClient = await getInfoClient()
      const portfolioData = await infoClient.portfolio(userAddress)
      return portfolioData
    },
    enabled: !!userAddress,
    staleTime: 60 * 1000, // 1 minutes
    gcTime: 60 * 1000, // 1 minutes
    retry: 3,
    retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
  })
}
